import { Link } from "react-router-dom";
import { ArrowUpRight, Leaf, Droplets, Wrench } from "lucide-react";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Stagger, StaggerItem } from "@/components/Reveal";
import { DevisCTA } from "@/components/DevisCTA";

const cards = [
  { icon: Leaf, tag: "🌿", title: "Parcs & Jardins", text: "Entretien, création, restauration et remise en état de vos espaces verts.", to: "/parcs-jardins", img: "https://images.pexels.com/photos/34174881/pexels-photo-34174881.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { icon: Droplets, tag: "🧽", title: "Nettoyage extérieur", text: "Façades, allées, cours, terrasses et traitements adaptés à chaque surface.", to: "/nettoyage-exterieur", img: "https://images.pexels.com/photos/14965464/pexels-photo-14965464.jpeg?auto=compress&cs=tinysrgb&w=1000" },
  { icon: Wrench, tag: "🔧", title: "Petites réparations", text: "Petits travaux et interventions diverses selon la nature du besoin.", to: "/petites-reparations", img: "https://images.unsplash.com/photo-1764670325965-618c104b0b07?auto=format&fit=crop&w=1000&q=80" },
];

export default function Services() {
  return (
    <div data-testid="services-page">
      <Seo title="Nos services — Sandro Services 06 | Alpes-Maritimes (06)" description="Entretien de jardins, nettoyage extérieur et petites réparations dans les Alpes-Maritimes. Découvrez tous les services de Sandro Services 06." />
      <PageHero chapter="Nos services" title="Une entreprise polyvalente pour tous vos extérieurs" subtitle="Entretien, création, restauration, nettoyage et petites réparations — regroupés en trois grandes expertises." />

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-14 md:py-20">
        <Stagger className="grid gap-8 lg:grid-cols-3">
          {cards.map((c) => (
            <StaggerItem key={c.title}>
              <Link to={c.to} data-testid={`services-card-${c.to.slice(1)}`} className="group block h-full bg-white border border-line rounded-2xl overflow-hidden hover:shadow-lift transition-all duration-300 hover:-translate-y-1">
                <div className="relative h-56 overflow-hidden">
                  <img src={c.img} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <span className="absolute top-4 left-4 w-11 h-11 grid place-items-center rounded-full bg-sand/90 text-lg">{c.tag}</span>
                </div>
                <div className="p-8">
                  <div className="flex items-center justify-between">
                    <h3 className="font-display text-2xl text-forest">{c.title}</h3>
                    <ArrowUpRight className="text-olive group-hover:rotate-45 transition-transform duration-300" />
                  </div>
                  <p className="mt-3 text-sm text-ink-soft leading-relaxed">{c.text}</p>
                </div>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <DevisCTA />
    </div>
  );
}
